import { render, staticRenderFns } from "./BlockedQuests.vue?vue&type=template&id=0e47a102&scoped=true&"
import script from "./BlockedQuests.vue?vue&type=script&lang=js&"
export * from "./BlockedQuests.vue?vue&type=script&lang=js&"
import style0 from "./BlockedQuests.vue?vue&type=style&index=0&id=0e47a102&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e47a102",
  null
  
)

export default component.exports